import { TeamRole } from '@/api/types/teams';

export interface TeamRoleItem {
  name: string;
  value: TeamRole;
  description: string;
}

export const teamRoleItems: TeamRoleItem[] = [
  {
    name: 'Team Member',
    value: 'team_member' as const,
    description: 'Standard team member.',
  },
  {
    name: 'Team Admin',
    value: 'team_admin' as const,
    description: 'Team admin access allows for managing team members.',
  },
];

export const teamRoleValues = ['team_admin', 'team_member'] satisfies [TeamRole, ...TeamRole[]];
export const teamRoleFilterValues = ['all', ...teamRoleValues] as const;

export function getTeamRoleName(role: TeamRole): string {
  return teamRoleItems.find((item) => item.value === role)?.name || role;
}
